/**
 * @overview 提交数据公共逻辑
 *
 * @author  huojinzhao
 */

import { $http } from "@/utils";

/**
 * 解析服务端错误/自定义错误
 *
 * @return  {Array}
 */
function errorResolve(error) {
  if (typeof error === "string") return [error];

  const { errors, message } = error;

  if (errors) {
    const values = Object.values(errors);

    return values.reduce((acc, value) => acc.concat(value), []);
  }

  if (message) return [message];

  return ["网络异常，请联系网站管理员或稍后重试！"];
}

/**
 * 展示服务端错误/自定义错误
 *
 * @param {Array}   payload   -   错误数据体
 */
function errorAlert(payload) {
  const errors = errorResolve(payload);
  const message = errors.reduce((
    acc,
    value,
  ) => `${acc}<div>${value}</div>`, "");

  this.$notify.error({
    title: "提交数据发生错误",
    message,
    dangerouslyUseHTMLString: true,
    duration: 0,
  });
}

function submit({ data, id, uri }) {
  if (!data || !uri) throw new Error("$form.submit参数有误！");

  const isCreate = id === undefined || Number.isNaN(id);

  const action = isCreate
    ? {
      method: "post",
      url: uri,
    }
    : {
      method: "put",
      url: `${uri}/${id}`,
    };

  return $http[action.method](action.url, data);
}

const rules = {
  /**
   * 必填验证
   * @param {String} fieldName - 必填项的label名称，如“姓名”
   * @param {String} type - 数据类型，默认为string
   * @param {String} trigger - 触发方式，默认为‘blur,change’
   * @param {String} message - 提示信息，默认为‘{fieldName}不能为空’
   */
  required: (
    fieldName,
    type = "string",
    trigger = "",
    message = `${fieldName}不能为空`,
    validator,
  ) => ({
    type,
    trigger,
    message,
    required: true,
    validator,
  }),

  // 账号验证（支持数字、字母）
  userName: {
    pattern: /^(([a-zA-Z0-9_]+\s?)+|[a-zA-Z0-9_]*)$/,
    message: "账号格式不正确",
    trigger: "blur",
  },

  // 账号密码的验证规则
  userPassword: {
    min: 6,
    message: "密码长度为6位-20位",
    trigger: "blur",
  },
};

export default {
  errorResolve,
  errorAlert,
  rules,
  submit,
};
